import React from "react";

const PlanComparison = ({ recommendations, processingTimes }) => {
  // Get all unique keys for table rows, in a consistent order
  const getAllKeys = (plans) => {
    const keys = new Set();
    plans.forEach((plan) => {
      Object.keys(plan || {}).forEach((k) => keys.add(k));
    });
    // Remove 'Feature' and return sorted for consistency
    return Array.from(keys).filter((k) => k !== "Feature");//.sort();
  };

  // Format time to include units
  const formatTime = (seconds) => {
    if (isNaN(seconds)) return 'N/A';
    return `${Number(seconds).toFixed(2)} seconds`;
  };

  return (
    <div className="my-8">
      
      {/* Recommendations Section */}
      {recommendations && recommendations.length > 0 && (
        <div className="mt-12">
          <h2 className="text-2xl font-bold text-blue-700 mb-4 text-center">Recommendations</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {recommendations.map((rec, idx) => (
              <div key={idx} className="bg-white border-l-4 border-blue-400 shadow rounded-lg p-5">
                <div className="text-blue-800 font-semibold mb-1">{rec.goal}</div>
                <div className="text-lg font-bold text-green-700 mb-1">{rec.recommendedPlan}</div>
                <div className="text-gray-700">{rec.reason}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Processing Times Section */}
      {processingTimes && (
        <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">Processing Time</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
            <div className="p-3 bg-white rounded shadow-sm border-l-4 border-blue-400">
              <div className="text-sm text-gray-600">Files Upload</div>
              <div className="text-lg font-bold text-blue-700">{formatTime(processingTimes.upload_files)}</div>
            </div>
            <div className="p-3 bg-white rounded shadow-sm border-l-4 border-green-400">
              <div className="text-sm text-gray-600">Data Extraction</div>
              <div className="text-lg font-bold text-green-700">{formatTime(processingTimes.data_extraction)}</div>
            </div>
            <div className="p-3 bg-white rounded shadow-sm border-l-4 border-purple-400">
              <div className="text-sm text-gray-600">{"Data Processing (markdown)"}</div>
              <div className="text-lg font-bold text-purple-700">{formatTime(processingTimes.markdown_extraction)}</div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="p-3 bg-white rounded shadow-sm border-l-4 border-orange-400">
              <div className="text-sm text-gray-600">Plan Recognition</div>
              <div className="text-lg font-bold text-orange-700">{formatTime(processingTimes.plans_extraction)}</div>
            </div>
            <div className="p-3 bg-white rounded shadow-sm border-l-4 border-pink-400">
              <div className="text-sm text-gray-600">Plan Comparison</div>
              <div className="text-lg font-bold text-pink-700">{formatTime(processingTimes.compare_plans)}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanComparison; 